module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row puzzle-quote"
  }, [_c('label', {
    staticClass: "puzzle-quote__quote-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("Quote " + _vm._s(_vm.number + 1))]), _vm._v(" "), _c('button', {
    staticClass: "puzzle-quote__close-btn col-md-10",
    on: {
      "click": _vm.deleteQuote
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "puzzle-quote__sub-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("Text")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mb-1"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.text),
      expression: "quote.text"
    }],
    staticClass: "form-control",
    attrs: {
      "id": ("title-" + _vm.number),
      "rows": "3",
      "placeholder": "Enter quote text"
    },
    domProps: {
      "value": (_vm.quote.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "text", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "puzzle-quote__sub-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("More Info")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mb-1"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.more_info),
      expression: "quote.more_info"
    }],
    staticClass: "form-control",
    attrs: {
      "id": ("title-" + _vm.number),
      "rows": "2",
      "placeholder": "Enter more info"
    },
    domProps: {
      "value": (_vm.quote.more_info)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "more_info", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "puzzle-quote__sub-label col-md-2",
    attrs: {
      "for": ("title-" + _vm.number)
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 mb-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quote.link),
      expression: "quote.link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": ("title-" + _vm.number),
      "placeholder": "Enter link"
    },
    domProps: {
      "value": (_vm.quote.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.quote, "link", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7189d6be","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/games/puzzles/PuzzleQuote.vue
// module id = 940
// module chunks = 0